import React from "react";

import { FSCIDomainsCircle } from "src/components/fsci_domains_circle/fsci_domains_circle";
import { V2Domains } from "src/pages/reports/fsci/v2/types";

export type ReportDomainsCircleProps = {
    readonly inline?: boolean;
    readonly activeDomain?: V2Domains;
};

export const DomainsCircle = (props: ReportDomainsCircleProps): React.ReactElement => <FSCIDomainsCircle {...props} />;
